import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { whatsappNumbersQuery } from "../../lib/whatsapp/whatsappNumbersQuery"

export function useSyncWhatsappNumberMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async () => {
      const response = await axios.post<Response>(`/integrations/whatsapp/refresh-phone-numbers`)

      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: whatsappNumbersQuery().queryKey })
    },
  })
}
